// feld_pfad-Grammatik -> bestehende PUT-Endpunkte. KEINE neuen Schreibpfade:
// Audit-Trail und 409-Gate der vorhandenen Routen greifen automatisch.
const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

export interface BelegKontext { auftragId?: number; bestellungId?: number }

const POSITIONS_FELD_MAP: Record<string, string> = {
  einzelpreis: 'preis_einzeln',
  bezeichnung: 'beschreibung',
  menge: 'menge',
  rabatt_prozent: 'rabatt_prozent',
};

const ZAHL_FELDER = new Set([
  'menge', 'preis_einzeln', 'rabatt_prozent', 'gesamtrabatt_prozent',
  'zahlungsziel_tage', 'skonto_prozent', 'skonto_frist_tage',
]);

// Pflicht-Zahlfelder: leere/ungültige Eingaben sollen NICHT gesendet werden.
// Backend hat keine null-Guards für diese Felder -> würde 500-Fehler werfen.
// Stattdessen: no-op, refetch stellt vorherigen Wert wieder her.
const REQUIRED_NUMERIC_FIELDS = new Set(['menge', 'preis_einzeln']);

/** de-DE-Eingabe ("76,70") -> API-Wert. Leerstring bei Zahlfeldern -> null (Feld leeren). */
function konvertiere(feld: string, wert: string): string | number | null {
  if (!ZAHL_FELDER.has(feld)) return wert;
  const bereinigt = wert.trim().replace(',', '.');
  if (bereinigt === '') return null;
  return parseFloat(bereinigt);
}

export function feldPfadZuRequest(
  kontext: BelegKontext, feldPfad: string, wert: string,
): { url: string; body: Record<string, unknown> } | null {
  const teile = feldPfad.split('/');
  if (teile[0] === 'auftrag' && kontext.auftragId != null && teile.length === 2) {
    const wert_konvertiert = konvertiere(teile[1], wert);
    // Ungültige Eingabe (NaN) für alle Zahlfelder -> no-op
    if (typeof wert_konvertiert === 'number' && isNaN(wert_konvertiert)) {
      return null;
    }
    // Pflicht-Zahlfelder: leere Eingaben nicht senden (kein Backend-Null-Guard).
    // No-op: refetch stellt Wert wieder her.
    if (REQUIRED_NUMERIC_FIELDS.has(teile[1]) && wert_konvertiert === null) {
      return null;
    }
    return {
      url: `${API_URL}/api/auftraege/${kontext.auftragId}`,
      body: { [teile[1]]: wert_konvertiert },
    };
  }
  if (teile[0] === 'position' && kontext.auftragId != null && teile.length === 3) {
    const feld = POSITIONS_FELD_MAP[teile[2]];
    if (!feld) return null;
    const wert_konvertiert = konvertiere(feld, wert);
    // Ungültige Eingabe (NaN) für alle Zahlfelder -> no-op
    if (typeof wert_konvertiert === 'number' && isNaN(wert_konvertiert)) {
      return null;
    }
    // Pflicht-Zahlfelder: leere Eingaben nicht senden (kein Backend-Null-Guard).
    // No-op: refetch stellt Wert wieder her.
    if (REQUIRED_NUMERIC_FIELDS.has(feld) && wert_konvertiert === null) {
      return null;
    }
    return {
      url: `${API_URL}/api/auftraege/${kontext.auftragId}/positionen/${teile[1]}`,
      body: { [feld]: wert_konvertiert },
    };
  }
  if (teile[0] === 'bestellung-position' && kontext.bestellungId != null && teile.length === 3) {
    const feld = POSITIONS_FELD_MAP[teile[2]];
    if (!feld) return null;
    const wert_konvertiert = konvertiere(feld, wert);
    // Ungültige Eingabe (NaN) für alle Zahlfelder -> no-op
    if (typeof wert_konvertiert === 'number' && isNaN(wert_konvertiert)) {
      return null;
    }
    // Pflicht-Zahlfelder: leere Eingaben nicht senden (kein Backend-Null-Guard).
    // No-op: refetch stellt Wert wieder her.
    if (REQUIRED_NUMERIC_FIELDS.has(feld) && wert_konvertiert === null) {
      return null;
    }
    return {
      url: `${API_URL}/api/bestellungen/${kontext.bestellungId}/positionen/${teile[1]}`,
      body: { [feld]: wert_konvertiert },
    };
  }
  return null;
}
